import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import ImoveisPage from "../pages/imoveis/page";
import ProprietariosPage from "../pages/proprietarios/page";

const HomePage = lazy(() => import('../pages/home/page'));
const ServicosPage = lazy(() => import('../pages/servicos/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const SolicitarAtendimentoPage = lazy(() => import('../pages/solicitar-atendimento/page'));
const LPProprietariosPage = lazy(() => import('../pages/lp-proprietarios/page'));
const LPCampanhaBrasiliaPage = lazy(() => import('../pages/lp-campanha-brasilia/page'));
const ResidencialIngridPage = lazy(() => import('../pages/residencial-ingrid/page'));
const VillaJardinsPage = lazy(() => import('../pages/villa-jardins/page'));
const ParqueCastanheirasPage = lazy(() => import('../pages/parque-das-castanheiras/page'));
const ArboretoMirantePage = lazy(() => import('../pages/arboreto-mirante/page'));
const RealClassicResortPage = lazy(() => import('../pages/lp-real-classic-resort/page'));
const CalculadoraValorPage = lazy(() => import('../pages/calculadora-valor/page'));
const BlogListPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/post/page'));
const GuiaPage = lazy(() => import('../pages/guia/page'));
const SaoPauloGuidePage = lazy(() => import('../pages/guia/sao-paulo/page'));
const BrasiliaGuidePage = lazy(() => import('../pages/guia/brasilia/page'));
const MiamiGuidePage = lazy(() => import('../pages/guia/miami/page'));
const FlorianopolisGuidePage = lazy(() => import('../pages/guia/florianopolis/page'));
const CarteiraAtivosPage = lazy(() => import('../pages/carteira-ativos/page'));
const LPInvestidoresInternacionaisPage = lazy(() => import('../pages/lp-investidores-internacionais/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/servicos',
    element: <ServicosPage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: "/imoveis",
    element: <ImoveisPage />,
  },
  {
    path: '/proprietarios',
    element: <ProprietariosPage />,
  },
  {
    path: '/solicitar-atendimento',
    element: <SolicitarAtendimentoPage />,
  },
  {
    path: '/lp-proprietarios',
    element: <LPProprietariosPage />,
  },
  {
    path: '/lp-campanha-brasilia',
    element: <LPCampanhaBrasiliaPage />,
  },
  {
    path: '/residencial-ingrid',
    element: <ResidencialIngridPage />,
  },
  {
    path: '/aguas-claras/villa-jardins-apartamento-alto-padrao-3-ou-4-quartos',
    element: <VillaJardinsPage />,
  },
  {
    path: '/villa-jardins',
    element: <Navigate to="/aguas-claras/villa-jardins-apartamento-alto-padrao-3-ou-4-quartos" replace />,
  },
  {
    path: '/parque-das-castanheiras',
    element: <ParqueCastanheirasPage />,
  },
  {
    path: '/arboreto-mirante',
    element: <ArboretoMirantePage />,
  },
  {
    path: '/lp-real-classic-resort-cobertura-4-quartos-3-quartos-aguas-claras-df',
    element: <RealClassicResortPage />,
  },
  {
    path: '/real-classic',
    element: <Navigate to="/lp-real-classic-resort-cobertura-4-quartos-3-quartos-aguas-claras-df" replace />,
  },
  {
    path: '/blog',
    element: <BlogListPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/calculadora-valor-imovel',
    element: <CalculadoraValorPage />,
  },
  {
    path: '/guia',
    element: <GuiaPage />,
  },
  {
    path: '/guia/sao-paulo',
    element: <SaoPauloGuidePage />,
  },
  {
    path: '/guia/brasilia',
    element: <BrasiliaGuidePage />,
  },
  {
    path: '/guia/miami',
    element: <MiamiGuidePage />,
  },
  {
    path: '/guia/florianopolis',
    element: <FlorianopolisGuidePage />,
  },
  {
    path: '/carteira-ativos',
    element: <CarteiraAtivosPage />,
  },
  {
    path: '/lp-investidores-internacionais',
    element: <LPInvestidoresInternacionaisPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;